import ContentStepComponentView from './ContentStepComponentView.html';
import './ContentStepComponent.scss';
import { MessageTemplateContentTypes } from 'modules/application/detail/contents/messageTemplates/createMessageTemplateSidebar/CreateMessageTemplateSidebarController';
import { MessageTemplateStatus } from '../../../../contents/messageTemplates/models/MessageTemplateStatus';
import { ActiveMessagesConstants } from '../../ActiveMessagesConstants';
import { GROWTH_ACTIVE_MESSAGE_WA_CONTENT_STEP_MESSAGE_TEMPLATE_SELECTED, GROWTH_ACTIVE_MESSAGE_WA_RESPONSE_STEP_STARTED, } from '../../../GrowthSegmentEvents';
import { CampaignType } from '../../models/CampaignType';
import { ActiveMessagesFeatures } from '../../ActiveMessagesFeatures';
import { isNullOrWhiteSpace } from 'data/string';
import { debounce } from 'data/function';
const MARKETING = 'MARKETING';
class ContentStepComponentController {
    static $inject = ['$translate', '$element', '$scope', 'LoadingService', 'MessageTemplateService', 'MessageTemplateUtil', 'BlipToastService', 'GrowthSegmentService', 'AlertService', '$rootScope'];
    constructor($translate, $element, $scope, LoadingService, MessageTemplateService, MessageTemplateUtil, BlipToastService, GrowthSegmentService, AlertService, $rootScope) {
        'ngInject';
        this.$translate = $translate;
        this.$element = $element;
        this.$scope = $scope;
        this.LoadingService = LoadingService;
        this.MessageTemplateService = MessageTemplateService;
        this.MessageTemplateUtil = MessageTemplateUtil;
        this.BlipToastService = BlipToastService;
        this.GrowthSegmentService = GrowthSegmentService;
        this.AlertService = AlertService;
        this.$rootScope = $rootScope;
        this.isLoading = false;
        this.hasErrors = true;
        this.isTemplateChosen = false;
        this.showLanguagesForMessageTemplate = ActiveMessagesFeatures.showLanguagesForMessageTemplateDefautValue;
        this.enableLazyLoadingTemplates = ActiveMessagesFeatures.templatesLazyLoadingDefaultValue;
        this.DEFAULT_LANGUAGE = 'pt_BR';
        this.TEMPLATE_LANGUAGE_SEPARATOR = ' • ';
        this.CHARACTERS = ' !"#$%&\'()*+,-./0123456789:;<=>?@[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~';
        this.MAX_VARIABLE_HEIGHT = 140;
        this.canvas = document.createElement('canvas');
        this.inputMinLength = 3;
        this.onInputDebouneTimeout = 1000;
        this.loadingTemplates = false;
        this.helperMessageTemplateText = '';
        this.isBatchType = () => this.campaignType == CampaignType.Batch;
        this.verifyButtons = (mediaMessageTemplate) => mediaMessageTemplate.buttons != undefined ? mediaMessageTemplate : undefined;
        this.setTemplate = (event) => {
            this.isTemplateChosen = false;
            this.selectedMessageTemplateLanguage = undefined;
            this.resetFields();
            this.selectedMessageTemplate = event.detail?.value;
            this.isTemplateChosen = this.selectedMessageTemplate != undefined;
            this.messageTemplateLanguageOptions = new Array();
            this.invalidFile = false;
            if (!this.isTemplateChosen) {
                return;
            }
            const messageTemplateTranslations = [...this.messageTemplates.values()].find((template) => template.name == this.selectedMessageTemplate).translations;
            for (let i = 0; i < messageTemplateTranslations.length; i++) {
                const translation = messageTemplateTranslations[i];
                this.messageTemplateLanguageOptions.push({ label: translation.language, value: translation.language });
            }
            if (messageTemplateTranslations.length == 1) {
                this.selectedMessageTemplateLanguage = messageTemplateTranslations[0].language;
                this.chooseLanguageAndShowTemplate({ detail: { value: this.selectedMessageTemplateLanguage } });
            }
        };
        this.showTemplate = (event) => {
            this.selectedMessageTemplate = event.detail?.value;
            this.selectedMessageTemplateLanguage = this.messageTemplates.get(this.selectedMessageTemplate)?.translations[0]?.language ?? this.DEFAULT_LANGUAGE;
            this.showTemplateGivenLanguage(this.selectedMessageTemplateLanguage);
        };
        this.chooseLanguageAndShowTemplate = (event) => {
            if (this.messageTemplateLanguageOptions.length != 1) {
                this.selectedMessageTemplateLanguage = event.detail?.value;
            }
            this.showTemplateGivenLanguage(event.detail?.value);
        };
        this.setPreview = (preview) => {
            this.inputMedia = preview.detail.value;
            this.preview = preview.detail.value;
        };
        this.onVariableChange = () => {
            this.LoadingService.startLoading();
            const changedVariablesArray = [];
            let variableField;
            let variableFieldId;
            for (let i = 1; i <= this.messageTemplateVariables.length; i++) {
                variableFieldId = `{{${i}}}`;
                variableField = document.querySelector(`bds-input[field-name="${variableFieldId}"]`);
                if (variableField.value) {
                    this.changedVariables = {
                        id: variableFieldId,
                        value: variableField.value,
                    };
                }
                else {
                    this.changedVariables = {
                        id: variableFieldId,
                        value: variableFieldId,
                    };
                }
                this.resizeField(variableField);
                changedVariablesArray.push(this.changedVariables);
            }
            this.updateTemplateDescription(changedVariablesArray);
            this.LoadingService.stopLoading();
        };
        this.fillAudienceAndMessageParams = (paramsValues) => {
            paramsValues.forEach((value, index) => {
                this.audienceParams[index] = value;
                this.messageParams.push(`${index}`);
            });
            this.audienceParams = paramsValues.length == 0 ? undefined : this.audienceParams;
            this.messageParams = paramsValues.length == 0 ? undefined : this.messageParams;
        };
        this.isAllowProceed = () => {
            if (this.campaignType == CampaignType.Batch) {
                return this.showMessageTemplate && !this.hasErrors;
            }
            else {
                return this.showMessageTemplate;
            }
        };
        this.validateMessageTotalLength = async () => {
            let messageTotalLength = this.originalMessageTemplateText.length;
            messageTotalLength = this.sumButtonTextLength(messageTotalLength);
            messageTotalLength = this.sumVariableTextLength(messageTotalLength);
            if (messageTotalLength > ActiveMessagesConstants.MAXIMUM_MESSAGE_SIZE) {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('activeMessages.send.content.buttonActionEmpty.alertTitle'),
                    msg: await this.$translate('activeMessages.send.content.exceededMaximumMTLength'),
                });
                return false;
            }
            return true;
        };
        this.hasErrorsOnBatchType = (hasErrors = true) => {
            this.hasErrors = hasErrors;
        };
        this.onInput = (event) => {
            const input = event.target;
            if (input.value.length < this.inputMinLength) {
                return;
            }
            this.onInputDebounced(input.value);
        };
        this.handleUseLiteApi = (event, newValue) => {
            this.resetFields();
            this.selectedMessageTemplate = undefined;
            this.messageTemplateOptions = new Array();
            this.messageTemplates = new Map();
            if (newValue === true && this.messageTemplateOptionsMarketing) {
                this.messageTemplateOptions = [...this.messageTemplateOptionsMarketing];
                this.messageTemplates = this.messageTemplatesMarketing;
                return;
            }
            if (this.messageTemplateOptionsAllCategories) {
                this.messageTemplateOptions = [...this.messageTemplateOptionsAllCategories];
                this.messageTemplates = this.messageTemplatesAllCategories;
            }
        };
        this.chooseMessageTemplate = (event) => {
            this.selectedMessageTemplate = event.detail?.value;
        };
    }
    async $onInit() {
        this.messageTemplateLanguageOptions = new Array();
        this.showMessageTemplate = false;
        this.invalidFile = false;
        this.showLanguagesForMessageTemplate = await ActiveMessagesFeatures.isToShowLanguagesForMessageTemplate();
        this.enableLazyLoadingTemplates = await ActiveMessagesFeatures.isTemplatesLazyLoading();
        if (!this.enableLazyLoadingTemplates) {
            await this.loadTemplates();
        }
        else {
            this.onInputDebounced = debounce(this.loadTemplatesPartial, this.onInputDebouneTimeout);
            this.helperMessageTemplateText = await this.$translate('activeMessages.send.content.messageTemplate.helperMessage');
        }
    }
    async loadTemplates() {
        let messageTemplateResult = [];
        try {
            this.LoadingService.startLoading();
            const whatsAppMessageTemplateList = await this.MessageTemplateService.get({
                status: MessageTemplateStatus.Approved,
            });
            this.messageTemplates = new Map();
            this.messageTemplateOptions = new Array();
            messageTemplateResult = [...this.messageTemplates, ...this.MessageTemplateUtil.convertToMessageTemplate(whatsAppMessageTemplateList.data)];
            this.loadTemplatesToOptions(messageTemplateResult);
        }
        catch (error) {
            console.error(error);
            this.BlipToastService.show('danger', {
                title: await this.$translate('activeMessages.send.content.errorMessageTemplate.title'),
                msg: await this.$translate('activeMessages.send.content.errorMessageTemplate.body'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    loadTemplatesToOptions(messageTemplateResult) {
        this.messageTemplates = new Map();
        this.messageTemplateOptions = new Array();
        messageTemplateResult.forEach((messageTemplate) => {
            this.messageTemplateOptions.push({ label: messageTemplate.name, value: messageTemplate.name });
            this.messageTemplates.set(messageTemplate.name, messageTemplate);
        });
    }
    async loadTemplatesPartial(messageTemplateName) {
        let messageTemplateResult = [];
        try {
            this.loadingTemplates = true;
            const whatsAppMessageTemplateList = await this.MessageTemplateService.getCacheManaged({
                limit: 400,
                templateName: messageTemplateName,
                status: MessageTemplateStatus.Approved,
            });
            this.messageTemplateOptions = new Array();
            this.messageTemplates = new Map();
            messageTemplateResult = [...this.messageTemplates, ...this.MessageTemplateUtil.convertToMessageTemplate(whatsAppMessageTemplateList.data)];
            this.loadTemplatesToOptions(messageTemplateResult);
        }
        catch {
            this.BlipToastService.show('danger', {
                title: await this.$translate('activeMessages.send.content.errorMessageTemplate.title'),
                msg: await this.$translate('activeMessages.send.content.errorMessageTemplate.body'),
            });
        }
        finally {
            this.loadingTemplates = false;
        }
    }
    showTemplateGivenLanguage(language) {
        setTimeout(() => {
            this.LoadingService.startLoading();
            this.resetFields();
            if (!this.selectedMessageTemplate || !language) {
                this.LoadingService.stopLoading();
                return;
            }
            const messageTemplate = this.messageTemplates.get(this.selectedMessageTemplate);
            const messageTemplateTranslation = messageTemplate.translations.find(tranlation => tranlation.language == language);
            const mediaMessageTemplate = this.customMessageTemplateContent(messageTemplateTranslation);
            const buttonMessageTemplate = this.verifyButtons(messageTemplateTranslation);
            if (buttonMessageTemplate) {
                this.templateButtons = buttonMessageTemplate.buttons;
                this.templateButtons.forEach(element => {
                    this.buildButtonMessageTemplate(element);
                });
            }
            else {
                this.messageTemplateButtonsVariables = false;
            }
            if (mediaMessageTemplate) {
                this.customMessageTemplate = true;
                this.buildMessageTemplate(mediaMessageTemplate);
            }
            else {
                this.customMessageTemplate = false;
                this.buildMessageTemplate(messageTemplateTranslation);
            }
            this.$scope.$apply();
            this.showMessageTemplate = true;
            this.LoadingService.stopLoading();
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_STEP_MESSAGE_TEMPLATE_SELECTED, {
                messageTemplateType: messageTemplate.translations[0]?.type,
                messageTemplateVariables: this.messageTemplateVariables ? true : false,
                messageTemplateButtonsVariables: this.messageTemplateButtonsVariables ? true : false,
                activeMessageType: this.campaignType,
            });
            this.$scope.$broadcast(ActiveMessagesConstants.EVENT_CONTENT_STEP_MESSAGE_TEMPLATE_CHANGE);
        });
    }
    buildMessageTemplate(mediaMessageTemplate) {
        this.messageTemplateType = mediaMessageTemplate.type;
        this.messageTemplateText = mediaMessageTemplate.text;
        this.originalMessageTemplateText = this.messageTemplateText;
        this.messageTemplateVariables = this.getMessageTemplateVariables(this.messageTemplateText);
    }
    buildButtonMessageTemplate(buttonMessageTemplate) {
        const buttonVariable = this.getMessageTemplateVariables(buttonMessageTemplate?.url);
        if (buttonVariable != undefined && buttonVariable != '') {
            this.messageTemplateButtonType = buttonMessageTemplate.type;
            this.messageTemplateButtonText = buttonMessageTemplate.text;
            this.messageTemplateButtonsVariables = buttonVariable;
        }
    }
    customMessageTemplateContent(messageTemplate) {
        return messageTemplate.type == 'image'
            || messageTemplate.type == 'document'
            || messageTemplate.type == 'video' ? messageTemplate : undefined;
    }
    resetFields() {
        this.invalidFile = false;
        this.showMessageTemplate = false;
        this.messageTemplateButtonText = undefined;
        this.messageTemplateButtonType = undefined;
        this.messageTemplateButtonsVariables = undefined;
        this.messageTemplateText = undefined;
        this.messageTemplateType = undefined;
        this.templateButtons = undefined;
        this.preview = undefined;
        this.hasErrors = false;
        if (this.isBatchType()) {
            return;
        }
        let variableField;
        if (this.messageTemplateVariables) {
            for (let i = 1; i <= this.messageTemplateVariables.length; i++) {
                variableField = document.querySelector(`bds-input[field-name="{{${i}}}"]`);
                variableField.value = '';
            }
            this.messageTemplateVariables = undefined;
        }
        const inputMedia = document.querySelector('bds-input[field-name="inputMedia"]');
        if (inputMedia) {
            inputMedia.value = '';
        }
    }
    getMessageTemplateVariables(text) {
        if (text) {
            return text.match(/{{\d{1,10}}}/gm);
        }
    }
    resizeField(variableField) {
        let numberOfRows = variableField.value.length / this.getMaxCharactersTillNewRow(variableField);
        numberOfRows = numberOfRows < 1 ? 1 : numberOfRows;
        if (variableField.offsetHeight < this.MAX_VARIABLE_HEIGHT || numberOfRows < variableField.rows) {
            variableField.rows = Math.ceil(numberOfRows);
        }
    }
    getMaxCharactersTillNewRow(variableField) {
        const context = this.canvas.getContext('2d');
        context.font = this.getCanvasFont(variableField);
        const metrics = context.measureText(this.CHARACTERS);
        const averageCharactersWidth = metrics.width / this.CHARACTERS.length;
        return Math.round(variableField.offsetWidth / averageCharactersWidth);
    }
    getCssStyle(element, prop) {
        return window.getComputedStyle(element, undefined).getPropertyValue(prop);
    }
    getCanvasFont(el = document.body) {
        const fontWeight = this.getCssStyle(el, 'font-weight') || 'normal';
        const fontSize = this.getCssStyle(el, 'font-size') || '16px';
        const fontFamily = this.getCssStyle(el, 'font-family') || 'Times New Roman';
        return `${fontWeight} ${fontSize} ${fontFamily}`;
    }
    updateTemplateDescription(variables) {
        for (let i = 0; i < variables.length; i++) {
            if (i === 0) {
                this.messageTemplateText = this.originalMessageTemplateText.replace(variables[i].id, variables[i].value);
            }
            else {
                this.messageTemplateText = this.messageTemplateText.replace(variables[i].id, variables[i].value);
            }
        }
        const list = this.getPreviewElement();
        list.forEach((element) => {
            const elementHtml = element;
            elementHtml.innerHTML = this.MessageTemplateUtil.formatMessageToPreviewView(this.messageTemplateText);
        });
    }
    getPreviewElement() {
        const element = this.$element[0];
        return element.querySelectorAll('.amtc__description');
    }
    async saveContentTabData() {
        if (!await this.validateMessageTotalLength()) {
            return;
        }
        const paramsValues = [];
        this.audienceParams = {};
        this.messageParams = [];
        if (!this.isBatchType()) {
            if (this.inputMedia) {
                paramsValues.push(this.inputMedia);
            }
            if (this.templateButtons) {
                let variableField;
                let variableFieldId;
                for (let i = 1; i <= this.templateButtons.length; i++) {
                    variableFieldId = `button-{{${i}}}`;
                    variableField = document.querySelector(`bds-input[field-name="${variableFieldId}"]`);
                    if (variableField == undefined) {
                        continue;
                    }
                    const buttonActionValue = variableField?.value;
                    if (buttonActionValue == undefined || buttonActionValue.trim() == '') {
                        this.BlipToastService.show('danger', {
                            title: await this.$translate('activeMessages.send.content.buttonActionEmpty.alertTitle'),
                            msg: await this.$translate('activeMessages.send.content.buttonActionEmpty.alertBody'),
                        });
                        return;
                    }
                    paramsValues.push(variableField.value);
                }
            }
            let isTextVariablesEmpty = false;
            if (this.messageTemplateVariables) {
                let variableFieldId = '{{0}}';
                let variableField = document.querySelector(`bds-input[field-name="${variableFieldId}"]`);
                for (let i = 0; i < this.messageTemplateVariables.length; i++) {
                    variableFieldId = `{{${i + 1}}}`;
                    variableField = document.querySelector(`bds-input[field-name="${variableFieldId}"]`);
                    if (variableField?.value) {
                        paramsValues.push(variableField.value);
                    }
                    else {
                        paramsValues.push(' ');
                        isTextVariablesEmpty = true;
                    }
                }
            }
            this.fillAudienceAndMessageParams(paramsValues);
            if (this.customMessageTemplate) {
                await this.uploadAttachment(this.preview);
            }
            if (this.invalidFile) {
                return;
            }
            if (isTextVariablesEmpty) {
                await this.toggleVariablesAlert();
                return;
            }
        }
        else {
            const columnsNames = this.fileSummary.columnsNames?.split(',');
            const numberOfMessageTemplateVariables = (this.messageTemplateButtonsVariables ? 1 : 0) + (this.messageTemplateVariables?.length ?? 0) + (this.customMessageTemplate ? 1 : 0);
            columnsNames.forEach((columnName, index) => {
                if (index == 0 || index > numberOfMessageTemplateVariables) {
                    return;
                }
                paramsValues.push(columnName);
            });
            this.fillAudienceAndMessageParams(paramsValues);
        }
        this.handleNextStep();
    }
    async uploadAttachment(uri) {
        try {
            this.LoadingService.startLoading();
            const { reason, } = await this.MessageTemplateService.uploadAttachment({
                uri,
            });
            if (reason) {
                let errorTitle;
                let errorDescription;
                if (this.messageTemplateType === MessageTemplateContentTypes.DOCUMENT) {
                    errorTitle = await this.$translate('messageTemplateSidebar.newTemplate.errors.documentFormat.title');
                    errorDescription = await this.$translate('messageTemplateSidebar.newTemplate.errors.documentFormat.description');
                }
                else if (this.messageTemplateType === MessageTemplateContentTypes.VIDEO) {
                    if (reason.description === ActiveMessagesConstants.INVALID_VIDEO_SIZE_ERROR_MESSAGE) {
                        errorTitle = await this.$translate('messageTemplateSidebar.newTemplate.errors.videoSize.title');
                        errorDescription = await this.$translate('messageTemplateSidebar.newTemplate.errors.videoSize.description');
                    }
                    else {
                        errorTitle = await this.$translate('messageTemplateSidebar.newTemplate.errors.videoFormat.title');
                        errorDescription = await this.$translate('messageTemplateSidebar.newTemplate.errors.videoFormat.description');
                    }
                }
                else {
                    errorTitle = await this.$translate('messageTemplateSidebar.newTemplate.errors.imageFormat.title');
                    errorDescription = await this.$translate('messageTemplateSidebar.newTemplate.errors.imageFormat.description');
                }
                this.BlipToastService.show('danger', {
                    title: errorTitle,
                    msg: errorDescription,
                });
                this.invalidFile = true;
                return;
            }
            else {
                this.invalidFile = false;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    sumButtonTextLength(messageTotalLength) {
        if (!this.templateButtons) {
            return messageTotalLength;
        }
        for (let i = 1; i <= this.templateButtons.length; i++) {
            const variableField = document.querySelector(`bds-input[field-name="${`button-{{${i}}}`}"]`);
            if (!variableField || isNullOrWhiteSpace(variableField.value)) {
                continue;
            }
            messageTotalLength += variableField?.value.length;
        }
        return messageTotalLength;
    }
    sumVariableTextLength(messageTotalLength) {
        if (!this.messageTemplateVariables) {
            return messageTotalLength;
        }
        for (let i = 0; i < this.messageTemplateVariables.length; i++) {
            const variableField = document.querySelector(`bds-input[field-name="${`{{${i + 1}}}`}"]`);
            if (!variableField) {
                continue;
            }
            if (variableField?.value) {
                messageTotalLength += variableField.value.length;
            }
            else {
                messageTotalLength += 1;
            }
        }
        return messageTotalLength;
    }
    async handleNextStep() {
        const $data = {
            name: await this.$translate('activeMessages.send.content.title'),
            value: [{
                    description: this.selectedMessageTemplate + this.TEMPLATE_LANGUAGE_SEPARATOR + this.selectedMessageTemplateLanguage,
                }],
            params: {
                template: this.selectedMessageTemplate,
                language: this.selectedMessageTemplateLanguage,
                audienceParams: this.audienceParams,
                messageParams: this.messageParams,
            },
        };
        this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_RESPONSE_STEP_STARTED, {
            activeMessageType: this.campaignType,
            language: this.selectedMessageTemplateLanguage,
            content: this.selectedMessageTemplate,
        });
        this.callback({ $data });
        this.next();
    }
    handlePreviousStep() {
        this.previous();
    }
    async toggleVariablesAlert() {
        const alertTitle = await this.$translate('activeMessages.send.content.variableAlert.title');
        const alertBody = await this.$translate('activeMessages.send.content.variableAlert.bodyText');
        const confirmButton = await this.$translate('activeMessages.send.content.variableAlert.okButton');
        const cancelButton = await this.$translate('activeMessages.send.content.variableAlert.cancelButton');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody,
            variant: 'warning',
            icon: 'attention',
            buttons: {
                cancel: cancelButton,
                confirm: confirmButton,
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => this.handleNextStep(),
            },
        });
    }
}
ContentStepComponentController.$inject = ['$translate', '$element', '$scope', 'LoadingService', 'MessageTemplateService', 'MessageTemplateUtil', 'BlipToastService', 'GrowthSegmentService', 'AlertService', '$rootScope'];
export const ContentStep = {
    template: ContentStepComponentView,
    controller: ContentStepComponentController,
    controllerAs: '$ctrl',
    bindings: {
        step: '@?',
        botIdentifier: '@?',
        next: '&?',
        previous: '&?',
        callback: '&?',
        fileSummary: '<?',
        campaignType: '@?',
    },
};
